// extracted by mini-css-extract-plugin
export default {"doctors":"doctor_doctors__l-qXu","doctor":"doctor_doctor__oygXL"};